define("shared/components/shared/schedule-navbar", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "lodash", "moment", "later/utils/schedule-navbar", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _lodash, _moment, _scheduleNavbar, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _updateDate, _getPreviousDate, _getPresentDate, _getNextDate;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"lodash",0,"moment",0,"later/utils/schedule-navbar",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(receiver, privateSet, fn) { _assertClassBrand(privateSet, receiver); return fn; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div
    aria-label={{t "schedule.navigation.aria.schedule_navigation"}}
    class="cCN--toolbar"
    data-test-id="schedule-navbar"
    role="group"
    tabindex="0"
    {{did-update this.onUpdate @targetDate @targetDateInterval}}
  >
    {{#if (has-block "leftSide")}}
      {{yield to="leftSide"}}
    {{else if @disregardDates}}
      {{! TODO: Placeholder to not break styling }}
      <div></div>
    {{else}}
      <div class="cCN--toolGroup cCN--toolGroup__left">
        <div class="o--btnGroup">
          <Shared::Ui::Button
            @class={{concat-classes "cCN--toolbar__btn--today" (if this.dateRangeIncludesToday "is--active")}}
            @onClick={{this.onClickToday}}
            @variant="unstyled"
            aria-label={{t "shared_words.today"}}
            data-test-id="today-button"
            type="button"
          >
            {{t "shared_words.today"}}
          </Shared::Ui::Button>
          <Shared::Ui::Button
            @class="cCN--toolbar__btn--dateRange"
            @onClick={{this.onClickPrevious}}
            @variant="unstyled"
            aria-label={{t "schedule.navigation.aria.previous_week"}}
            data-test-id="previous-button"
            type="button"
          >
            {{svg-jar "nav-left" class="o--icon"}}
          </Shared::Ui::Button>
          <Shared::Ui::Button
            @class="cCN--toolbar__btn--dateRange"
            @onClick={{this.onClickNext}}
            @variant="unstyled"
            aria-label={{t "schedule.navigation.aria.next_week"}}
            data-test-id="next-button"
            type="button"
          >
            {{svg-jar "nav-right" class="o--icon"}}
          </Shared::Ui::Button>
        </div>
        <div class="cCN--toolbar__dateTimezone">
          <h2
            aria-label={{t "schedule.navigation.aria.current_date_range"}}
            class="cCN--toolbar__date"
            id="fc-dom-1"
            tabindex="0"
          >
            {{this.dateRangeFormatted}}
          </h2>
          {{! Timezone Indicator }}
          <p
            aria-label={{t "schedule.navigation.aria.timezone"}}
            class="cCN--toolbar__timezone"
            tabindex="0"
            title={{this.timezone}}
          >
            {{this.timezone}}
          </p>
        </div>
      </div>
    {{/if}}
    <div class="cCN--toolGroup cCN--toolGroup__right">
      {{#if @disregardDates}}
        {{! Timezone }}
        <div class="cCN--toolbar__dateTimezone">
          <p
            aria-label={{t "schedule.navigation.aria.timezone"}}
            class="cCN--toolbar__timezone"
            tabindex="0"
            title={{this.timezone}}
          >
            {{this.timezone}}
          </p>
        </div>
      {{/if}}
      {{! Calendar View Links }}
      <div aria-label={{t "schedule.navigation.aria.schedule_views"}} role="group">
        {{#let (component (if @useExternalLinks "link-to-external" "link-to")) as |DynamicLinkTo|}}
          {{#if this.displayAdditionalButtons}}
            <DynamicLinkTo
              @activeClass="is--active"
              @route="cluster.schedule.stories"
              aria-label={{t "calendar.views.stories"}}
              class="o--btn o--btn--outline cCN--toolbar__btn--calView fc-storiesButton-button"
              data-test-id="stories-link"
              role="link"
            >
              {{t "calendar.views.stories"}}
            </DynamicLinkTo>
          {{/if}}
  
          <div class="o--btnGroup u--m__l__sm">
            {{#if this.displayAdditionalButtons}}
              <DynamicLinkTo
                @activeClass="is--active"
                @route="cluster.schedule.preview-grid"
                aria-label={{t "calendar.views.preview"}}
                class="o--btn o--btn--outline cCN--toolbar__btn--calView fc-previewButton-button"
                data-test-id="preview-link"
                role="link"
              >
                {{t "calendar.views.preview"}}
              </DynamicLinkTo>
            {{/if}}
            <DynamicLinkTo
              @activeClass="is--active"
              @query={{hash calendarView="timeGridWeek" targetDate=@targetDate}}
              @route="cluster.schedule.calendar"
              aria-label={{t "calendar.views.week"}}
              class="o--btn o--btn--outline cCN--toolbar__btn--calView fc-timeGridWeek-button"
              role="link"
            >
              {{t "calendar.views.week"}}
            </DynamicLinkTo>
            <DynamicLinkTo
              @activeClass="is--active"
              @query={{hash calendarView="dayGridMonth" targetDate=@targetDate}}
              @route="cluster.schedule.calendar"
              aria-label={{t "calendar.views.month"}}
              class="o--btn o--btn--outline cCN--toolbar__btn--calView fc-dayGridMonth-button"
              role="link"
            >
              {{t "calendar.views.month"}}
            </DynamicLinkTo>
            <DynamicLinkTo
              @activeClass="is--active"
              @route="cluster.schedule.list"
              aria-label={{t "calendar.views.list"}}
              class="o--btn o--btn--outline cCN--toolbar__btn--calView fc-listButton-button"
              role="link"
            >
              {{t "calendar.views.list"}}
            </DynamicLinkTo>
          </div>
        {{/let}}
      </div>
    </div>
  </div>
  */
  {
    "id": "Ja5N+vL9",
    "block": "[[[11,0],[16,\"aria-label\",[28,[37,0],[\"schedule.navigation.aria.schedule_navigation\"],null]],[24,0,\"cCN--toolbar\"],[24,\"data-test-id\",\"schedule-navbar\"],[24,\"role\",\"group\"],[24,\"tabindex\",\"0\"],[4,[38,1],[[30,0,[\"onUpdate\"]],[30,1],[30,2]],null],[12],[1,\"\\n\"],[41,[48,[30,6]],[[[1,\"    \"],[18,6,null],[1,\"\\n\"]],[]],[[[41,[30,3],[[[1,\"    \"],[10,0],[12],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,0],[14,0,\"cCN--toolGroup cCN--toolGroup__left\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--btnGroup\"],[12],[1,\"\\n        \"],[8,[39,5],[[16,\"aria-label\",[28,[37,0],[\"shared_words.today\"],null]],[24,\"data-test-id\",\"today-button\"],[24,4,\"button\"]],[[\"@class\",\"@onClick\",\"@variant\"],[[28,[37,6],[\"cCN--toolbar__btn--today\",[52,[30,0,[\"dateRangeIncludesToday\"]],\"is--active\"]],null],[30,0,[\"onClickToday\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,0],[\"shared_words.today\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[39,5],[[16,\"aria-label\",[28,[37,0],[\"schedule.navigation.aria.previous_week\"],null]],[24,\"data-test-id\",\"previous-button\"],[24,4,\"button\"]],[[\"@class\",\"@onClick\",\"@variant\"],[\"cCN--toolbar__btn--dateRange\",[30,0,[\"onClickPrevious\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,7],[\"nav-left\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[39,5],[[16,\"aria-label\",[28,[37,0],[\"schedule.navigation.aria.next_week\"],null]],[24,\"data-test-id\",\"next-button\"],[24,4,\"button\"]],[[\"@class\",\"@onClick\",\"@variant\"],[\"cCN--toolbar__btn--dateRange\",[30,0,[\"onClickNext\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,7],[\"nav-right\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"cCN--toolbar__dateTimezone\"],[12],[1,\"\\n        \"],[10,\"h2\"],[15,\"aria-label\",[28,[37,0],[\"schedule.navigation.aria.current_date_range\"],null]],[14,0,\"cCN--toolbar__date\"],[14,1,\"fc-dom-1\"],[14,\"tabindex\",\"0\"],[12],[1,\"\\n          \"],[1,[30,0,[\"dateRangeFormatted\"]]],[1,\"\\n        \"],[13],[1,\"\\n\"],[1,\"        \"],[10,2],[15,\"aria-label\",[28,[37,0],[\"schedule.navigation.aria.timezone\"],null]],[14,0,\"cCN--toolbar__timezone\"],[14,\"tabindex\",\"0\"],[15,\"title\",[30,0,[\"timezone\"]]],[12],[1,\"\\n          \"],[1,[30,0,[\"timezone\"]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]],[]]],[1,\"  \"],[10,0],[14,0,\"cCN--toolGroup cCN--toolGroup__right\"],[12],[1,\"\\n\"],[41,[30,3],[[[1,\"      \"],[10,0],[14,0,\"cCN--toolbar__dateTimezone\"],[12],[1,\"\\n        \"],[10,2],[15,\"aria-label\",[28,[37,0],[\"schedule.navigation.aria.timezone\"],null]],[14,0,\"cCN--toolbar__timezone\"],[14,\"tabindex\",\"0\"],[15,\"title\",[30,0,[\"timezone\"]]],[12],[1,\"\\n          \"],[1,[30,0,[\"timezone\"]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[10,0],[15,\"aria-label\",[28,[37,0],[\"schedule.navigation.aria.schedule_views\"],null]],[14,\"role\",\"group\"],[12],[1,\"\\n\"],[44,[[50,[52,[30,4],\"link-to-external\",\"link-to\"],0,null,null]],[[[41,[30,0,[\"displayAdditionalButtons\"]],[[[1,\"          \"],[8,[30,5],[[16,\"aria-label\",[28,[37,0],[\"calendar.views.stories\"],null]],[24,0,\"o--btn o--btn--outline cCN--toolbar__btn--calView fc-storiesButton-button\"],[24,\"data-test-id\",\"stories-link\"],[24,\"role\",\"link\"]],[[\"@activeClass\",\"@route\"],[\"is--active\",\"cluster.schedule.stories\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,0],[\"calendar.views.stories\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n        \"],[10,0],[14,0,\"o--btnGroup u--m__l__sm\"],[12],[1,\"\\n\"],[41,[30,0,[\"displayAdditionalButtons\"]],[[[1,\"            \"],[8,[30,5],[[16,\"aria-label\",[28,[37,0],[\"calendar.views.preview\"],null]],[24,0,\"o--btn o--btn--outline cCN--toolbar__btn--calView fc-previewButton-button\"],[24,\"data-test-id\",\"preview-link\"],[24,\"role\",\"link\"]],[[\"@activeClass\",\"@route\"],[\"is--active\",\"cluster.schedule.preview-grid\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,0],[\"calendar.views.preview\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"          \"],[8,[30,5],[[16,\"aria-label\",[28,[37,0],[\"calendar.views.week\"],null]],[24,0,\"o--btn o--btn--outline cCN--toolbar__btn--calView fc-timeGridWeek-button\"],[24,\"role\",\"link\"]],[[\"@activeClass\",\"@query\",\"@route\"],[\"is--active\",[28,[37,10],null,[[\"calendarView\",\"targetDate\"],[\"timeGridWeek\",[30,1]]]],\"cluster.schedule.calendar\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,0],[\"calendar.views.week\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n          \"],[8,[30,5],[[16,\"aria-label\",[28,[37,0],[\"calendar.views.month\"],null]],[24,0,\"o--btn o--btn--outline cCN--toolbar__btn--calView fc-dayGridMonth-button\"],[24,\"role\",\"link\"]],[[\"@activeClass\",\"@query\",\"@route\"],[\"is--active\",[28,[37,10],null,[[\"calendarView\",\"targetDate\"],[\"dayGridMonth\",[30,1]]]],\"cluster.schedule.calendar\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,0],[\"calendar.views.month\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n          \"],[8,[30,5],[[16,\"aria-label\",[28,[37,0],[\"calendar.views.list\"],null]],[24,0,\"o--btn o--btn--outline cCN--toolbar__btn--calView fc-listButton-button\"],[24,\"role\",\"link\"]],[[\"@activeClass\",\"@route\"],[\"is--active\",\"cluster.schedule.list\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,0],[\"calendar.views.list\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[5]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@targetDate\",\"@targetDateInterval\",\"@disregardDates\",\"@useExternalLinks\",\"DynamicLinkTo\",\"&leftSide\"],false,[\"t\",\"did-update\",\"if\",\"has-block\",\"yield\",\"shared/ui/button\",\"concat-classes\",\"svg-jar\",\"let\",\"component\",\"hash\"]]",
    "moduleName": "shared/components/shared/schedule-navbar.hbs",
    "isStrictMode": false
  });
  const DEFAULT_DATE_INTERVAL = _scheduleNavbar.ScheduleNavbarDateInterval.Week;
  let ScheduleNavbarComponent = _exports.default = (_dec = (0, _service.inject)('schedule/posts-pending-approval'), (_class = (_updateDate = /*#__PURE__*/new WeakSet(), _getPreviousDate = /*#__PURE__*/new WeakSet(), _getPresentDate = /*#__PURE__*/new WeakSet(), _getNextDate = /*#__PURE__*/new WeakSet(), class ScheduleNavbarComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _classPrivateMethodInitSpec(this, _getNextDate);
      _classPrivateMethodInitSpec(this, _getPresentDate);
      _classPrivateMethodInitSpec(this, _getPreviousDate);
      _classPrivateMethodInitSpec(this, _updateDate);
      _initializerDefineProperty(this, "postsPendingApproval", _descriptor, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor2, this);
      _initializerDefineProperty(this, "userConfig", _descriptor3, this);
      /**
       * Date interval is the space of time used to find and show items (i.e. "week", "month", etc.)
       */
      _initializerDefineProperty(this, "dateInterval", _descriptor4, this);
      /**
       * Date is a singular point in time in which the current date interval and offsets are used
       * to calculate a range of date objects (from start to end).
       */
      _initializerDefineProperty(this, "date", _descriptor5, this);
      _classPrivateMethodGet(this, _updateDate, _updateDate2).call(this, this.args.targetDate, this.args.targetDateInterval);
      this.postsPendingApproval.fetchCount.perform();
    }
    get displayAdditionalButtons() {
      const {
        firstProfile,
        hasMultipleSelected
      } = this.selectedSocialProfiles;
      return Boolean(firstProfile?.isInstagram && !hasMultipleSelected);
    }
    get timezone() {
      return this.userConfig.timeZoneIdentifier;
    }

    /**
     * Date range tuple where the first element is the "start" date, and the second element
     * is the "end" date (of whichever date-interval is active).
     */
    get dateRange() {
      return (0, _scheduleNavbar.getDateRange)(this.date, this.dateInterval, this.timezone);
    }
    get startDate() {
      return this.dateRange[0];
    }
    get endDate() {
      return this.dateRange[1];
    }
    get dateRangeFormatted() {
      if (this.dateInterval === _scheduleNavbar.ScheduleNavbarDateInterval.Month) {
        return this.startDate.format('MMMM YYYY');
      }
      if (this.dateInterval === _scheduleNavbar.ScheduleNavbarDateInterval.Week) {
        // Note: if both ends of our date range reside in the same month then we
        // leave the month out of the second half of the formatted date-string.
        // However, if they're in different months, we include the month in the
        // date-string for both ends of the date range.
        const isSameMonth = this.startDate.month() === this.endDate.month();
        const from = this.startDate.format('MMM D');
        const to = isSameMonth ? this.endDate.format('D') : this.endDate.format('MMM D');
        const year = this.endDate.format('YYYY');
        return `${from} - ${to}, ${year}`;
      }
      throw new Error(`Unsupported date interval provided: "${this.dateInterval}"`);
    }
    get dateRangeIncludesToday() {
      const presentDate = _classPrivateMethodGet(this, _getPresentDate, _getPresentDate2).call(this);
      return presentDate.isSameOrAfter(this.startDate) && presentDate.isSameOrBefore(this.endDate);
    }
    onUpdate(_element, _ref) {
      let [targetDate, targetDateInterval] = _ref;
      // Note: avoid updating tracked property if dates are already the same
      if (this.date.toISOString() !== (0, _moment.default)(targetDate).toISOString() || this.dateInterval !== targetDateInterval) {
        _classPrivateMethodGet(this, _updateDate, _updateDate2).call(this, targetDate, targetDateInterval);
      }
    }
    onClickPrevious() {
      this.date = _classPrivateMethodGet(this, _getPreviousDate, _getPreviousDate2).call(this);
      if ((0, _lodash.isFunction)(this.args.onChangeDate)) {
        this.args.onChangeDate(this.date, this.dateInterval);
      }
    }
    onClickToday() {
      if (this.dateRangeIncludesToday) {
        return;
      }
      this.date = _classPrivateMethodGet(this, _getPresentDate, _getPresentDate2).call(this);
      if ((0, _lodash.isFunction)(this.args.onChangeDate)) {
        this.args.onChangeDate(this.date, this.dateInterval);
      }
    }
    onClickNext() {
      this.date = _classPrivateMethodGet(this, _getNextDate, _getNextDate2).call(this);
      if ((0, _lodash.isFunction)(this.args.onChangeDate)) {
        this.args.onChangeDate(this.date, this.dateInterval);
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "postsPendingApproval", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dateInterval", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return DEFAULT_DATE_INTERVAL;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "date", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "onUpdate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClickPrevious", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onClickPrevious"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClickToday", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onClickToday"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClickNext", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onClickNext"), _class.prototype)), _class));
  function _updateDate2(targetDate, targetDateInterval) {
    const unixDate = Number(targetDate);
    if ((0, _lodash.isNaN)(unixDate)) {
      this.date = (0, _scheduleNavbar.getPresentDate)(this.timezone);
    } else {
      this.date = (0, _moment.default)(unixDate).tz(this.timezone);
    }
    this.dateInterval = targetDateInterval ?? DEFAULT_DATE_INTERVAL;
  }
  function _getPreviousDate2() {
    return (0, _scheduleNavbar.getPreviousDate)(this.date, this.dateInterval);
  }
  function _getPresentDate2() {
    return (0, _scheduleNavbar.getPresentDate)(this.timezone);
  }
  function _getNextDate2() {
    return (0, _scheduleNavbar.getNextDate)(this.date, this.dateInterval);
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ScheduleNavbarComponent);
});